import { stringToSubscript } from "../../utils/stringToSubscript.js";
import {} from "../net/index.js";
import {} from "../node/index.js";
export function formatNode(net, node) {
    const subscript = stringToSubscript(node.id.toString());
    return `${node.name}${subscript}`;
}
//# sourceMappingURL=formatNode.js.map